// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"O5-z","upvote":"P5-z","downvote":"Q5-z","numVotes":"R5-z","votesDescription":"S5-z","report":"T5-z","voted":"U5-z","answerVoteBox":"V5-z","justReported":"W5-z"};